import {AppState} from './../../index';
import {createSelector} from 'reselect';

export const localitiesListSelector = () =>
  createSelector(
    (state: AppState) => state.localities.list,
    (item) => item,
  );

export const currentLocalitySelector = () =>
  createSelector(
    (state: AppState) => state.localities.current,
    (item) => item,
  );

export const isLocalityDeterminatedSelector = () =>
  createSelector(
    (state: AppState) => state.localities.isDeterminated,
    (item) => item,
  );
